import { Box } from "@mui/material";
import { Component } from "react";
import "./syva_logo.css";

export class SyvaLogo extends Component {
  render() {
    return <Box width="100%" p={2} className={"syva_logo"} sx={{ backgroundColor: "primary.main" }}></Box>;
  }
}
